import * as THREE from 'three'
// import Experience from './Experience.js'
import Experience from './Experience.js'
// import { camera, cameraControls } from './CameraControlsExperience.js'

const clock = new THREE.Clock()

export default class Renderer {
    constructor() {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera

        // globalThis.scene = this.scene

        this.setInstance()
    }

    setInstance() {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            alpha: true
        })

        // this.instance.toneMapping = THREE.CineonToneMapping
        // this.instance.toneMappingExposure = 1.75
        this.instance.shadowMap.enabled = true
        // this.instance.shadowMap.type = THREE.BasicShadowMap
        // this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.shadowMap.type = THREE.VSMShadowMap
        // this.instance.logarithmicDepthBuffer = true // Doesn't fix the flickering... Not z-index fighting?
        // this.instance.setClearColor('#211d20') // Background color
        // this.instance.setClearColor('#f0f8ff')
        // this.instance.getClearAlpha(false)
        this.instance.setSize(this.sizes.width, this.sizes.height)

        // Performance improvement on 4k and mobile. Too much to handle otherwise.
        if (this.sizes.width > 1920 || globalThis.mobile) {
            this.instance.setPixelRatio(1.5)
        }

        else {
            this.instance.setPixelRatio(this.sizes.pixelRatio)
        }

        globalThis.instance = this.instance
    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)

        if (this.sizes.width > 1920) {
            this.instance.setPixelRatio(1.5)
        }

        else {
            this.instance.setPixelRatio(this.sizes.pixelRatio)
        }
    }

    // anim() {
    //     const clock = new THREE.Clock()
    //     const delta = clock.getDelta();
    //     const elapsed = clock.getElapsedTime();
    //     const updated = cameraControls.update(delta);

    //     // if ( elapsed > 30 ) { return; }

    //     requestAnimationFrame(anim);

    //     if (updated) {
    //         this.renderer.render(this.scene, this.camera.instance);
    //         console.log('rendered');
    //     }

    // };

    update() {
        // this.instance.render(this.scene, this.camera.instance)
    }
}